import { motion } from "framer-motion";
import { Users } from "lucide-react";
import { Label } from "@/components/ui/label";
import { FormData, nameCountOptions } from "../types";

interface NameCountStepProps {
  formData: FormData;
  onChange: (field: keyof FormData, value: string) => void;
}

const NameCountStep = ({ formData, onChange }: NameCountStepProps) => {
  return (
    <motion.div
      key="nameCount"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-6"
    >
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <Users className="w-8 h-8 text-primary" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground mb-2">
          How Many Names Should Be Included?
        </h2>
        <p className="text-muted-foreground">
          Select how many names will appear in the song lyrics.
        </p>
      </div>

      <div className="space-y-4">
        <Label>Select one *</Label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {nameCountOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange("nameCount", option.value)}
              className={`p-4 rounded-xl border-2 transition-all text-center ${
                formData.nameCount === option.value
                  ? "border-primary bg-primary/5"
                  : "border-border hover:border-primary/50"
              }`}
            >
              <span className="font-medium">{option.label}</span>
            </button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default NameCountStep;
